var Lazy = function () {
    var tests;
    
    var loadJs = function () {    
        if (tests.bg) { 
            UL.getScriptCdn(
                'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/3.0.0/plugins/bgset/ls.bgset.min.js',
                config.bowerPath + 'lazysizes/plugins/bgset/ls.bgset.min.js'
            );
        }
        
        UL.getScriptCdn(
            'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/3.0.0/lazysizes.min.js',
            config.bowerPath + 'lazysizes/lazysizes.min.js',
            function () {
                $('img.lazyload').load(function() {
                    $(this).closest('.m-lazy-wrap').addClass('is-lazyloaded');
                });    
            }
        );
    };
    
    var test = function () {
        tests = {
            img: $('img.lazyload').length ? true : false,
            bg: $('.lazyload[data-bgset]').length ? true : false
        }
    };

    var init = function () {
        test();
        
        if (tests.img || tests.bg) {
            Polyfills.responsImg(loadJs);
        }    
    };

    return {
        init: init
    };
}();

UL.register(Lazy);
